<template>
  <button-base medium="whatsapp" :title="i18n.t('public.social.share_on_whatsapp')" class="whatsapp"
               @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import WhatsappMixin from '@/share/campaign/whatsapp-mixin'

export default {
  components: { ButtonBase },

  mixins: [WhatsappMixin]
}
</script>
